const qcNoteHR = {
    "view": {
        "message": {
            "releaseHasQCIssues": "Izdanja {{releaseName}} ima QC probleme, molimo uredite izdanje za detaljne QC povratne informacije, napravite potrebne promjene i ponovno pošaljite!",
            "trackHasQCIssues": "Pjesma {{trackName}} ima QC probleme, molimo uredite pjesmu za detaljne QC povratne informacije, napravite potrebne promjene i ponovno pošaljite!"
        }
    }
};

export default qcNoteHR;